export const slugify = (text, separator = "-") => {
  if (!text) {
    return ""
  }
  return text
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\s+/g, separator)
}

export const getSlugLink = (link, prefix, hash = "") => {
  const currentLink = link?.content?.main?.slug?.current
  if (!hash || hash == null || hash === "---") {
    hash = ""
  } else if (hash) {
    hash = "#" + hash
  }
  if (currentLink && prefix) {
    return "/" + prefix + "/" + currentLink + hash
  } else if (currentLink === "home") {
    return "/" + hash
  } else if (currentLink) {
    return "/" + currentLink + hash
  }
  return "/" + hash
}

export const blocksToText = (blocks, opts = {}) => {
  const defaults = { nonTextBehavior: "remove" }
  const options = Object.assign({}, defaults, opts)
  return blocks
    .map(block => {
      if (block._type !== "block" || !block.children) {
        return options.nonTextBehavior === "remove"
          ? ""
          : `[${block._type} block]`
      }
      return block.children.map(child => child.text).join("")
    })
    .join("\n\n")
}

export const timeToRead = (blocks, avgWordsPerMin = 250) => {
  const plainText = blocksToText(blocks)
  const wordCount = plainText.match(/\w+/g).length
  const time = Math.ceil(wordCount / avgWordsPerMin)
  return time + " min read"
}

const months = [
  {
    abbreviation: "Jan",
    name: "January",
  },
  {
    abbreviation: "Feb",
    name: "February",
  },
  {
    abbreviation: "Mar",
    name: "March",
  },
  {
    abbreviation: "Apr",
    name: "April",
  },
  {
    abbreviation: "May",
    name: "May",
  },
  {
    abbreviation: "Jun",
    name: "June",
  },
  {
    abbreviation: "Jul",
    name: "July",
  },
  {
    abbreviation: "Aug",
    name: "August",
  },
  {
    abbreviation: "Sep",
    name: "September",
  },
  {
    abbreviation: "Oct",
    name: "October",
  },
  {
    abbreviation: "Nov",
    name: "November",
  },
  {
    abbreviation: "Dec",
    name: "December",
  },
]

export const getMonth = date => {
  const d = new Date(date)
  return months[d.getMonth()]
}
export const getYear = (date, twoDigit) => {
  const d = new Date(date)
  const y = d.getFullYear().toString()
  return y.substring(twoDigit ? 2 : 0)
}
